<template>
  <div class="app-container">
    <el-card>
      <el-select
        v-model="type"
        size="mini"
        clearable
        placeholder="请选择"
        @change="changeTableType"
      >
        <el-option
          v-for="item in options"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        />
      </el-select>
      <span class="ml-10 mr-10">
        <media-select
          ref="media-select"
          v-model="table_params.params.advertiser_id"
          type="gdt"
          @change="changeAdvertiser"
        />
      </span>
      <el-input
        v-model="search_input"
        prefix-icon="el-icon-search"
        placeholder="名称搜索"
        clearable
        size="mini"
        class="search-input"
        @input="onSearchInput"
      />
      <div class="fr">
        <el-popover
          v-if="type === 'tracking'"
          placement="bottom"
          width="900px"
          trigger="click"
        >
          <!-- 筛选盒子 -->
          <div class="filter-box">
            <div
              v-for="(item, index) in filters"
              :key="index"
              class="filter-item"
            >
              <p>{{ item.title }}</p>
              <div class="item">
                <el-checkbox-group
                  v-model="item['checked']"
                  :max="1"
                  @change="changeCheck($event, item.fields)"
                >
                  <el-checkbox
                    v-for="ele in item.options"
                    :key="ele.label"
                    :label="ele.value"
                  >
                    {{ ele.label }}
                  </el-checkbox>
                </el-checkbox-group>
              </div>
            </div>
          </div>
          <el-button slot="reference" type="text" icon="el-icon-set-up">
            筛选
          </el-button>
        </el-popover>
      </div>
    </el-card>
    <el-card class="mt-20">
      <div class="table-toolbar-wrapper">
        <el-button
          icon="el-icon-plus"
          type="primary"
          size="mini"
          @click="add_track_show = true"
        >新建应用转化</el-button>
      </div>
      <app-table
        v-if="table_params.params.advertiser_id"
        ref="my-table"
        :table-key="type === 'tracking' ? track_table_key : package_table_key"
        :tablep="table_params.params"
        :page-size="15"
        :get-data="type === 'tracking' ? getConversionList : getPackageList"
      />
      <el-empty v-else description="请先选择广告主" />
    </el-card>
    <!-- 批量新增转化抽屉 -->
    <el-drawer
      title="批量新增转化"
      :visible.sync="add_track_show"
      direction="rtl"
      size="1200px"
      :before-close="closeAddDialog"
    >
      <h2 slot="title">批量新增转化</h2>
      <div v-if="add_track_show" class="create-track-box">
        <create-track @config="configAddDialog" @cancel="closeAddDialog" />
      </div>
    </el-drawer>
  </div>
</template>

<script>
import { isEmpty } from '@/utils/is';
// 转化接口
import ConvertResource from '@/api/tool/convert/gdt';
const convertResource = new ConvertResource();

import qs from 'qs';
// 获取应用
import PromotedObject from '@/api/tool/promoted-object/gdt';
const promotedObject = new PromotedObject();

// 渠道包接口
import ChannelPackageResource from '@/api/tool/channel-package/gdt';
const channelPackageResource = new ChannelPackageResource();

const retranslation = require('@/assets/json/retranslation.json');
export default {
  name: 'GdtTracking',
  components: {
    'app-table': () => import('@/components/app-table'),
    'create-track': () => import('./components/create-track'),
    'media-select': () => import('@/views/system/media-user-manage/function/media-select'),
  },
  data() {
    return {
      retranslation: retranslation,
      type: 'tracking',
      options: [
        { label: '转化列表', value: 'tracking' },
        { label: '渠道列表', value: 'package' },
      ],
      // 表格头部
      track_table_key: require('./module/track-table-key.js')(this),
      package_table_key: require('./module/package-table-key.js')(this),
      search_input: '',
      add_track_show: false,
      // 获取转化
      table_params: {
        loading: false,
        params: {
          advertiser_id: '',
          filtering: [],
          page: 1,
          limit: 15,
        },
        response: {},
      },
      // 获取应用
      get_promoted: {
        params: {
          advertiser_id: '',
        },
        response: {},
      },
      filters_show: false,
      // 筛选项
      filters: {
        promoted_object_id: {
          title: '应用',
          fields: 'promoted_object_id',
          options: [],
          checked: [],
        },
        access_status: {
          title: '状态',
          fields: 'access_status',
          options: [
            { label: '未激活', value: 'ACCESS_STATUS_PENDING' },
            { label: '已激活', value: 'ACCESS_STATUS_COMPLETED' },
          ],
          checked: [],
        },
        optimization_goal: {
          title: '优化目标',
          fields: 'optimization_goal',
          options: this.$store.getters.gdtEnum.api_optimization_goal,
          checked: [],
        },
      },
    };
  },
  methods: {
    // 转化名称搜索
    onSearchInput(val) {
      if (this.type === 'tracking') {
        this.changeCheck([val], 'conversion_name');
      } else {
        this.table_params.params.name = val;
        this.updateTable();
      }
    },

    // 获取转化列表
    getConversionList() {
      return new Promise((resolve, reject) => {
        convertResource
          .getConvert(qs.stringify(this.table_params.params))
          .then((response) => {
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },

    // 获取渠道包列表
    getPackageList() {
      return new Promise((resolve, reject) => {
        channelPackageResource
          .getChannelPackageApi(this.table_params.params)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },

    // 获取应用列表
    async getAppList() {
      await promotedObject
        .getPromotedObject(this.get_promoted.params)
        .then((response) => {
          this.get_promoted.response = response.list.map((item) => {
            const obj = {
              label: item.promoted_object_name,
              value: item.type_id,
            };
            return obj;
          });
          this.filters.promoted_object_id.options = this.get_promoted.response;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    // 改变广告主
    changeAdvertiser(val) {
      if (isEmpty(val)) {
        return;
      }
      this.get_promoted.params.advertiser_id = val;
      this.getAppList();
      this.updateTable();
    },

    // 改变表格类型
    changeTableType(val) {
      // 先还原表格请求参数
      const obj = {
        advertiser_id: '',
        page: 1,
        limit: 15,
      };
      this.$set(this.table_params, 'params', obj);
      this.$refs['media-select'].clearValue();
      val === 'tracking' ? (this.table_params.params.filtering = []) : '';
      if (!this.table_params.params.advertiser_id) {
        this.$message.warning('请先选择广告主！');
        return;
      }
      this.updateTable();
    },

    // 改变筛选项
    changeCheck(val, fields) {
      if (!this.table_params.params.advertiser_id) {
        this.$message.warning('请先选择广告主！');
        return;
      }
      const has_field = this.table_params.params.filtering.some((item) => {
        if (item.field === fields) {
          return true;
        }
      });

      if (has_field) {
        this.table_params.params.filtering.forEach((item, index) => {
          if (item.field === fields && val.length) {
            item.values = val;
          }
          if (!val.length || !val.toString()) {
            this.table_params.params.filtering.splice(index, 1);
          }
        });
      } else {
        const obj = {
          field: fields,
          operator: fields === 'access_status' ? 'IN' : 'EQUALS',
          values: val,
        };
        if (fields === 'conversion_name') {
          obj.operator = 'CONTAINS';
        }
        this.table_params.params.filtering.push(obj);
      }

      this.$refs['my-table'].seekTable();
    },

    // 更新表格
    updateTable() {
      if (this.$refs['my-table']) {
        this.$refs['my-table'].seekTable();
      }
    },

    // 确定
    configAddDialog() {
      this.updateTable();
      this.add_track_show = false;
    },

    // 取消
    closeAddDialog() {
      this.$confirm('存在未提交的配置信息，确定关闭当前窗口吗', '提示').then(() => {
        this.add_track_show = false;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.app-container {
  background: #f5f6f7;
  min-height: calc(100vh - 84px);
  .create-track-box {
    padding: 0px 20px 100px;
  }
}
.search-input {
  display: inline-block;
  width: 210px;
}
.filter-box {
  width: auto;
  height: 330px;
  background-color: #fff;
  .filter-item {
    width: 200px;
    height: 100%;
    overflow: auto;
    float: left;
    padding: 10px;
    border-right: 1px solid #dfe1e6;
    p {
      text-align: center;
      color: #939599;
    }
    .item {
      width: 100%;
      height: 270px;
      overflow: auto;
      .el-checkbox {
        display: block;
        width: 100%;
        height: 30px;
        line-height: 30px;
        white-space: nowrap;
      }
    }
  }
}
</style>
